module.exports = __webpack_public_path__ + "index_pc/img/tuili_6-7.a1d525bd.png";